<mat-card class="store-card minimal-card"
  [class.store-card--clickable]="mode() !== 'pending'"
  [class.store-card--draggable]="mode() === 'pending'">

  <!-- UPPER: avatar + mode badge + actions -->
  <div class="store-card-upper">
    <div class="store-card-identification">
      <div class="store-card-avatar">
        <mat-icon>storefront</mat-icon>
      </div>
      @if (mode() === 'owner' && enableSharedStores()) {
      <div class="store-card-owner-badge" [matTooltip]="'stores.invitations.ownerBadgeTooltip' | translate">
        <span class="store-card-owner-badge__circle">
          <i-tabler name="user-check" class="icon-10"></i-tabler>
        </span>
        <span class="store-card-owner-badge__label">{{ 'stores.invitations.ownerBadge' | translate }}</span>
      </div>
      }
      @if (mode() === 'owner' && enableSharedStores() && store()?.sharedWith?.length) {
      <button type="button" class="store-card-shared-trigger" [matMenuTriggerFor]="sharedWithMenu"
        [matTooltip]="'stores.detail.sharedWith.title' | translate"
        (click)="$event.stopPropagation()">
        <i-tabler name="users" class="icon-12"></i-tabler>
        <span class="store-card-shared-trigger__count">{{ store()!.sharedWith!.length }}</span>
      </button>
      <mat-menu #sharedWithMenu="matMenu" panelClass="store-card-shared-menu">
        <div class="store-card-shared-menu__header" (click)="$event.stopPropagation()">
          <i-tabler name="users" class="icon-12"></i-tabler>
          <span>{{ 'stores.detail.sharedWith.title' | translate }}</span>
        </div>
        @for (user of store()!.sharedWith!; track user.email) {
        <div class="store-card-shared-menu__entry" (click)="$event.stopPropagation()">
          <span class="store-card-shared-menu__avatar" aria-hidden="true">{{ user.name.charAt(0).toUpperCase() }}</span>
          <span class="store-card-shared-menu__info">
            <span class="store-card-shared-menu__name">{{ user.name }}</span>
            <span class="store-card-shared-menu__email">{{ user.email }}</span>
          </span>
          <button type="button" class="store-card-shared-menu__revoke"
            [matTooltip]="'stores.invitations.revoke.action' | translate"
            (click)="$event.stopPropagation(); onRevokeShare($event, user.email)">
            <i-tabler name="user-minus" class="icon-12"></i-tabler>
          </button>
        </div>
        }
        <div class="store-card-shared-menu__footer"></div>
      </mat-menu>
      }
      @if (mode() === 'shared' && enableSharedStores()) {
      <div class="store-card-shared-badge" [matTooltip]="'stores.invitations.billedByOwner' | translate">
        <span class="store-card-shared-badge__circle">
          <i-tabler name="users" class="icon-10"></i-tabler>
        </span>
        <span class="store-card-shared-badge__label">{{ 'stores.invitations.sharedBadge' | translate }}</span>
      </div>
      }
    </div>

    <div class="store-card-actions-row">
      @if (mode() === 'pending') {
      <button mat-icon-button data-tour="pending-invitation-accept"
        [matTooltip]="'stores.sharedWithMe.acceptAction' | translate"
        [disabled]="isAccepting()" (click)="onAccept($event)">
        @if (isAccepting()) {
        <mat-spinner diameter="16"></mat-spinner>
        } @else {
        <mat-icon>check</mat-icon>
        }
      </button>
      } @else {
      <button mat-icon-button [matTooltip]="'stores.tooltip.viewStore' | translate" (click)="onView($event)">
        <mat-icon>visibility</mat-icon>
      </button>
      <button mat-icon-button [matTooltip]="'stores.tooltip.editStore' | translate" (click)="onEdit($event)">
        <mat-icon>edit</mat-icon>
      </button>
      @if (mode() === 'owner' && enableSharedStores()) {
      @if (store()?.onboarding?.isComplete) {
      <button mat-icon-button [matTooltip]="'stores.tooltip.shareStore' | translate" (click)="onShare($event)">
        <mat-icon>share</mat-icon>
      </button>
      } @else {
      <button mat-icon-button disabled [matTooltip]="'stores.tooltip.shareStoreIncomplete' | translate">
        <mat-icon>share</mat-icon>
      </button>
      }
      }
      <button mat-icon-button color="warn" [matTooltip]="'stores.tooltip.deleteStore' | translate"
        (click)="onDelete($event)">
        <mat-icon>delete</mat-icon>
      </button>
      }
    </div>
  </div>

  <!-- LOGO ROW -->
  <div class="store-card-logo-row">
    <div class="store-card-provider-logo store-card-provider-logo--centered">
      @if (isAmazonProvider(currentProvider())) {
      <span class="provider-logo-wrap">
        <img class="provider-logo provider-logo--light" src="assets/images/providers-logos/amazon.png"
          [alt]="currentProvider()" />
        <img class="provider-logo provider-logo--dark" src="assets/images/providers-logos/amazon-white.png"
          [alt]="currentProvider()" />
      </span>
      } @else {
      <img class="provider-logo" [src]="getProviderLogo(currentProvider())" [alt]="currentProvider()" />
      }
    </div>
  </div>

  <!-- NAME ROW -->
  <div class="store-card-name-row">
    <h3 class="store-card-title" [matTooltip]="currentName()" matTooltipShowDelay="300">
      {{ currentName() }}
    </h3>
  </div>

  <!-- STATUS ROW -->
  <div class="store-card-status-row">
    @if (mode() === 'pending') {
    <span class="store-card-status-badge store-card-status-badge--pending">
      {{ 'stores.invitations.pendingBadge' | translate }}
    </span>
    } @else {
    <span class="store-card-status-text" [class.complete-status]="store()?.onboarding?.isComplete"
      [class.incomplete-status]="!store()?.onboarding?.isComplete">
      {{ (store()?.onboarding?.isComplete ? 'stores.status.complete' : 'stores.status.incomplete') | translate }}
    </span>
    }
  </div>

  <!-- METRICS ROW -->
  <div class="store-card-metrics">
    @if (mode() === 'pending') {
    <div class="store-card-metric">
      <span class="metric-label">
        <mat-icon class="metric-icon">link</mat-icon>
        {{ 'stores.invitations.invitedOn' | translate }}
      </span>
      <span class="metric-value">{{ (invitation()?.invitedAt | date:'mediumDate') || '---' }}</span>
    </div>
    <div class="store-card-metric">
      <span class="metric-label">
        <mat-icon class="metric-icon">schedule</mat-icon>
        {{ 'stores.invitations.expiresOn' | translate }}
      </span>
      <span class="metric-value">{{ (invitation()?.expiresAt | date:'mediumDate') || '---' }}</span>
    </div>
    } @else {
    <div class="store-card-metric">
      <span class="metric-label">
        <mat-icon class="metric-icon">link</mat-icon>
        {{ 'stores.fieldListTable.Linked on' | translate }}
      </span>
      <span class="metric-value">{{ (store()?.linkedAt | date:'mediumDate') || '---' }}</span>
    </div>
    <div class="store-card-metric">
      <app-popover #autoRemovePopover trigger="click"
        panelClass="store-auto-remove-popover-panel app-popover-panel--compact"
        [positions]="autoRemovePopoverPositions" [bodyComponent]="StoreAutoRemovePopoverComponent"
        [bodyInputs]="buildAutoRemovePopoverInputs(autoRemovePopover)">
        <button type="button" class="metric-label metric-label--info-trigger"
          [attr.aria-label]="'stores.autoRemovePopover.openHint' | translate">
          <mat-icon class="metric-icon">autorenew</mat-icon>
          {{ 'stores.autoRemoveLabel' | translate }}
          <i-tabler name="info-circle" class="metric-info-icon" aria-hidden="true" />
        </button>
      </app-popover>
      <span class="metric-value">
        {{ store()?.hasAutoRemove ? ('stores.yes' | translate) : ('stores.no' | translate) }}
      </span>
    </div>
    }
  </div>

  <!-- BADGES (owner / shared — onboarding complete) -->
  @if (mode() !== 'pending' && store()?.onboarding?.isComplete) {
  <div class="store-card-badges" [appColCount]="2">
    @if (enableDeliveryAddressStep()) {
    <span class="store-card-badge complete store-card-badge--actionable" [appColSpan]="1" role="button" tabindex="0"
      (click)="onUpdateDelivery($event)" (keydown.enter)="onUpdateDelivery($event)"
      (keydown.space)="onUpdateDelivery($event); $event.preventDefault()">
      <mat-icon class="badge-icon left">check</mat-icon>
      <span class="badge-label">{{ 'stores.details.deliveryReady' | translate }}</span>
      <mat-icon class="badge-icon right">settings</mat-icon>
    </span>
    }
    <span class="store-card-badge complete store-card-badge--actionable"
      [appColSpan]="enableDeliveryAddressStep() ? 1 : 2" role="button" tabindex="0"
      (click)="onUpdateThreshold($event)" (keydown.enter)="onUpdateThreshold($event)"
      (keydown.space)="onUpdateThreshold($event); $event.preventDefault()">
      <mat-icon class="badge-icon left">check</mat-icon>
      <span class="badge-label">{{ 'stores.details.thresholdReady' | translate }}</span>
      <mat-icon class="badge-icon right">settings</mat-icon>
    </span>
  </div>
  }

  <!-- INCOMPLETE BANNER (owner / shared — onboarding not complete) -->
  @if (mode() !== 'pending' && !store()?.onboarding?.isComplete) {
  <div class="store-card-badge warning">
    <mat-icon class="badge-icon left">warning</mat-icon>
    <span class="badge-label">{{ 'stores.banner.message' | translate }}</span>
    <a class="banner-action" data-tour="howCompleteLinkingStore-bannerAction" (click)="onCompleteSetup($event)">
      {{ 'stores.banner.action' | translate }}
    </a>
  </div>
  }


</mat-card>
